import * as yup from 'yup';
import i18n from '../../../../localization/i18n';
import {
    ACCOUNT_REGISTRATION_LABEL_PASSWORD_ERROR_MATCH,
    ACCOUNT_REGISTRATION_LABEL_PASSWORD_ERROR_REGEX,
    LABEL_FIELD_ERROR_REQUIRED,
} from '../../../../localization/resouceKeys';

export const accountRegistrationValidations = yup.object().shape({
    password: yup
        .string()
        .required(() => i18n.t(LABEL_FIELD_ERROR_REQUIRED))
        .matches(
            /^(?=.{7,})(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9])(?!.*(.)\1{2})(?!.*(.{3,})\2).*$/,
            () => i18n.t(ACCOUNT_REGISTRATION_LABEL_PASSWORD_ERROR_REGEX),
        ),
    passwordConfirm: yup
        .string()
        .required(() => i18n.t(LABEL_FIELD_ERROR_REQUIRED))
        .oneOf([yup.ref('password'), null], () =>
            i18n.t(ACCOUNT_REGISTRATION_LABEL_PASSWORD_ERROR_MATCH),
        ),
});
